import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CleanUpVinService {
  public static cleanVin(vin) {
    return (vin || '')
      .normalize('NFKD')
      .replace(/[\u0000-\u001F\u007F-\u009F\u200B\u200E\u200F\u2060\uFEFF\u00A0\u202A-\u202E]/g, '')
        // Remove invisible/control characters
        // \u0000-\u001F - ASCII control characters
        // \u007F-\u009F - Delete and C1 control characters
        // \u200B        - Zero-width space
        // \u200E-\u200F - LTR/RTL marks
        // \u2060        - Word joiner (invisible)
        // \uFEFF        - Zero Width No-Break Space / BOM
        // \u00A0        - Non-breaking space
        // \u202A-\u202E - Unicode Bidirectional Formatting characters
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase();
  }
}
